import {useEffect, useRef, useState} from 'react';

type Options = {
  rootMargin?: string;
};

const useInView = <T extends Element = HTMLDivElement>({rootMargin = '0px'}: Options = {}) => {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || inView) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      {rootMargin}
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [inView, rootMargin]);

  return {ref, inView};
};

export default useInView;
